export enum EndUserLicenseAgreementEndpoint {
  Base = '/documents/eula',
  Version = '/version',
  Last = '/last',
}
